import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getGrupoImpuesto } from "./GrupoImpuesto.service"

export function useGrupoImpuesto() {
  const queryClient = useQueryClient()
  const {
    data: grupoImpuesto,
    isLoading: grupoImpuestoIsLoading,
    error: grupoImpuestoError,
    refetch: grupoImpuestoRefetch,
  } = useQuery({
    queryKey: ["getGrupoImpuesto"],
    queryFn: () => getGrupoImpuesto(),
    staleTime: 1000 * 60 * 60 * 2,
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })
  const grupoImpuestoInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getGrupoImpuesto"] })

  return {
    grupoImpuesto,
    grupoImpuestoIsLoading,
    grupoImpuestoError,
    grupoImpuestoRefetch,
    grupoImpuestoInvalidation,
  }
}
